import {TRANSLATION, Yup} from '@/imports-files/components/add-to-job-modal';

export const UNSUCCESSFUL_EMAIL_VALUES =  {
    email: {
            cc:[],
            subject: '',
            email_body: ''
           }
}

export const UNSUCCESSFUL_EMAIL_VALIDATION =  Yup.object({
    email: Yup.object({
                        
    })
})

export const TEXTS = {
    active_or_unsuccessful: {
        heading: 'Unsuccessful Email'
    },
    move_candidates: {
        heading: 'Invitation Email'
    },
    send_sourced_invitation: {
        heading: 'Prospective Candidate Email'
    },
    To: 'To',
    Email_Body: 'Email Body',
    Subject: 'Subject',
    CC: 'CC',
    Save: 'Send',
    add_interview: {
        heading: 'Interview Scheduled Email'
    },
    setup_kanban_interview: {
        heading: 'Interview Scheduled Email'
    }
}